<style lang="less">
  @import "../styles/base.less";

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
  @media screen and (max-width: 1080px) {
.ivu-col-span-12{
  flex: 0 0 100% !important;
  max-width: 100% !important;;
}

  }
  .omp input{
    width: 130px;
  }
</style>
<style lang="css">
  @import "../styles/iconfont/iconfont.css";
</style>

<template>
  <div>
    <Row>
      <!-- :span="18" -->
      <Col style="width: 75%;">
      <Row>
        <Form inline :label-width="110" class="basicForm" ref="searchPbForm" :model="searchPbForm">
          <!-- <FormItem class="form-item" label="产品类型">
            <Select v-model="searchPbForm.productId" transfer class="width160" placeholder="请选择"
              @on-change="selectProType">
              <Option v-for="item in productTypeData" :value="item.productId" :key="item.productId"
                :label="item.productName"></Option>
            </Select>
          </FormItem> -->
          <!-- <FormItem class="form-item" label="一级半成品">
                <Select v-model="searchPbForm.proId" transfer  class="width250"  placeholder="请选择" @on-change="selectPro">
                  <Option v-for="item in productData" :value="item.id" :key="item.id" :label="item.name+'('+item.encode+')'"></Option>
                </Select>
              </FormItem>-->
          <FormItem class="form-item" label="订/工单编号" >
            <Input style="display: inline-block;" class="width130" type="text" v-model.trim="searchPbForm.code"  placeholder="请输入"/>
          </FormItem>
          <!-- <FormItem class="form-item" label="产品名称" >
            <Input style="display: inline-block;" class="width130" type="text" v-model.trim="searchPbForm.name" placeholder="请输入"/>
          </FormItem> -->
          <FormItem class="form-item" label="产品名称">
                  <Select v-model="searchPbForm.name" class="width160" filterable clearable placeholder="请选择">
                    <Option v-for="item in productList" :value="item" :key="item" :label="item"></Option>
                  </Select>
                </FormItem>
          <FormItem class="form-item" label="宽度(mm)">
            <Input style="display: inline-block;" class="width130" type="text" v-model.trim="searchPbForm.wide" placeholder="请输入"/>
          </FormItem>
          <FormItem class="form-item" label="状态">
            <Select  filterable v-model.trim="searchPbForm.status" transfer clearable class="width160" placeholder="请选择">
              <Option value="0">未拼版</Option>
            <!-- <Option value="1">拼版中</Option> -->
            <Option value="2">拼版完成</Option>
            </Select>
          </FormItem>
          <!-- <FormItem class="form-item" label="长度(m)" >
            <Input style="display: inline-block;" class="width130" type="text" v-model.trim="allLength" readonly="readonly" placeholder="自动计算"/>
          </FormItem> -->
          <!-- <FormItem class="form-item form-item-button" label="" :label-width="0" style="width: 120px">
          <Checkbox v-model="showSecondFlag" style="width: 100px;" @on-change="getReaminWidth"   >显示二级</Checkbox>
          </FormItem> -->
          <!-- <FormItem class="form-item form-item-button" label="" :label-width="0" style="width: 120px">
          <Checkbox v-model="showYPFlag" style="width: 100px;"  @on-change="allLength = ''"   >预拼</Checkbox>
          </FormItem> -->
        <!--      <FormItem class="form-item" label="" :label-width="0" >
                 <Checkbox v-model="paperFlag" style="width: 100px;">显示二级</Checkbox>
              </FormItem> -->
          <!-- <FormItem class="form-item" label="分割组数">
            <Input class="width130" type="number" v-model.trim="pbNum" placeholder="自动计算" />
          </FormItem> -->
          <!-- <FormItem class="form-item" label="拼版宽度">
            <Input class="width130" type="number" readonly="readonly" v-model.trim="pbwidth" placeholder="自动计算" />
          </FormItem> -->
          <!-- <FormItem class="form-item" label="拼版长度">
            <Input class="width130" type="text"  v-model.trim="pbLength" placeholder="自动计算" />
          </FormItem> -->
          <FormItem class="form-item form-item-button" label="" :label-width="0" style="width: 110px">
            <Button class="iconfont" type="primary" @click="searchDataBtn">&nbsp;查询</Button>
            <!-- <Button class="iconfont" type="primary" @click="savePbBtn">&nbsp;保存</Button>
            <Button class="iconfont marginLeft20" type="primary" @click="calculationPbBtn">&nbsp;计算</Button> -->
          </FormItem>



        </Form>
      </Row>
      <Row>
        <Table @on-selection-change="selectTab" :height="tableHeight" row-key="id" class="table" ref="pbTable" border
          :data="pbTableData" :columns="pbTableColumns" :loading="loading" highlight-row stripe>
          <!-- <template slot-scope="{ row,index }" slot="productLength">
                <div style="display: inline-block;margin-right: 5px;margin-bottom: 5px" v-for="(item,index) in row.widthArr" :key="index">
                  <Input type="text" v-model="item.width" style="width: 80px" clearable  placeholder="请输入" @on-change="inputRow"/>

                </div>
                <Button type="primary" shape="circle" icon="md-add" @click="addBtn(row,index)"></Button>

              </template>
-->
        </Table>
        <Row style="width:100%;display: flex;flex-direction: row; align-items: center;justify-content: center;">
                <Page :current="pageNum" :page-size="pageSize" :total="total" @on-change="handleChangePage" @on-page-size-change="handlePageSizeChange" show-total show-sizer style="margin-top:10px;text-align: center;" />
              </Row>
      </Row>
      </Col>
      <!-- :span="6" :push="0" -->
      <Col style="width: 24%;margin-left: 15px;" >
        <Row>
        <Form  :label-width="90" inline class="basicForm" ref="searchPbForms" :model="searchPbForms">
          
          <FormItem class="form-item" label="物料宽度" style="width: 210px;">
            <Select  filterable v-model.trim="searchPbForms.productWidth" transfer style="width: 110px;" placeholder="请选择"
              @on-change="getRemainLengthFun">
              <Option v-for="item in paperWideArr" :value="item.goodsIds" :key="item.goodsIds"
                :label="item.name"></Option>
            </Select>
          </FormItem>
          <FormItem class="form-item" style="width: 210px;" label="物料长度:">
            <div>{{ makeInfo.goodsLength }}(m)</div>
          </FormItem>
        </Form>
       
        <Form  :label-width="85" inline class="basicForm" >
          <FormItem class="form-item" style="width: 210px;" label="拼版长度:">
            <div style="font-size:18px;">{{ makeInfo.splitsOneLength }}(m)</div>
          </FormItem>
          <FormItem class="form-item omp" style="width: 200px;" label="分割数:">
            <!-- <div>{{ makeInfo.splitsNo }}</div> -->
            <Input style="display: inline-block;width: 120px;font-size:18px;" class="width130" type="text" v-model.trim="makeInfo.splitsNo" placeholder="请输入"/>
          </FormItem>
        </Form>
        <Form  :label-width="90" inline class="basicForm">
          <FormItem class="form-item" style="width: 100%;color: #326CFB;" label="拼版幅宽:">
            <div style="font-size:18px;">{{ makeInfo.splitsWideStr }} (mm)</div>
          </FormItem>
        </Form>
        <Form  :label-width="90" inline class="basicForm">
          <FormItem class="form-item" style="width: 210px;" label="总宽:">
            <div style="font-size:18px;">{{ makeInfo.splitsTotalWideDo }}mm</div>
          </FormItem>
        </Form>
      </Row>
      <Row>
        <Button class="iconfont " type="primary" style="display: inline-block;" @click="makeupOptFun">&nbsp;拼版</Button>

        <Button class="iconfont marginLeft20" type="primary" style="display: inline-block;" @click="makeupSaveFun">&nbsp;保存拼版结果</Button>
      </Row>
      <h3 style="margin-top: 20px;">
        拼版解析:{{ makeUpObj.splitsDetailsStr }}
        <!-- <span style="color: red;">{{tip}}</span> -->
      </h3>
      <!-- <Row class="marginTop20" v-if="imgUrl">
        <img :src="imgUrl" alt="" width="800" height="800" />
      </Row> -->
      <Row class="marginTop10" >
        <div style="position: relative;">
          <div style="position: absolute;top:200px; writing-mode: vertical-rl;transform: rotate(360deg);">走纸长度（物料:{{ makeUpObj.goodsLength }}m）</div>
          <div style="position: absolute;top:50px; ">裁切长度:<br>({{ !!makeUpObj.splitsOneLength?`${makeUpObj.splitsOneLength}/${makeUpObj.splitsTotalLength}`:' ' }}m)</div>
          <div style="margin-left: 50px;margin-top: 50px;"> 
            <span style="text-align: center;margin-left: 60px;">幅宽（物料:{{ makeUpObj.goodsWide }}mm）</span>
            <span style="display: inline-block; color: red;font-size:18px;">剩余宽度:{{ remWidth }}mm）</span>
            <div class="ceshi" style="width: 300px;height: 350px; ">
              <div class="icon"></div>
              <div style="display: flex;flex-direction: row;">
                <div v-for="(item,index) in makeDom" class="enums" :style="{ width: item.showWidth + 'px' }" :key="index">{{ item.reaWidth }}</div>
              </div>
              
            </div>
          </div>
        </div>
      </Row>
      </Col>
    </Row>
    <Modal title="修改" v-model="updateModalFlagOne" footer-hide>
      <Form ref='searchForm' :label-width="90" inline>
        <FormItem label="级别">
          <Select v-model="selectedRow.level" class="width360">
            <Option value="1">正常</Option>
            <Option value="2">紧急</Option>
          </Select>
          
        </FormItem>
        <!-- <FormItem label="机器">
          <Select v-model="selectedRow.machineName"  clearable class="width360" placeholder="请选择">
                    <Option v-for="item in processData" :value="item.name" :key="item.name" :label="item.name"></Option>
                  </Select>
        </FormItem> -->
        
      </Form>
      <Row style="text-align: center;margin-left: 35%">
        <Button type="primary" @click="submitUpdate" style="width: 70px">确定</Button>
        <Button @click="updateModalFlagOne = false" class="marginLeft20" style="width: 70px">取消</Button>
      </Row>
    </Modal>
  </div>
</template>

<script>
  import {
    getFirstProductList,
    getPbList,
    savePbResult,
    generatePbResultImg,
    getPbProducts,
    getNoMakeupProNameList,
    findListByProductId,
    findGoodsWidth,
    findGoodsLength,
    getPageList,
    makeupOpt,
    getMakeupInfos,
    getPaperWide,
    recallMakeupSave,
    cutCommonUpdate,
    cutPaperMakeupPDF,
    cutGoSlice,
    cutCommonDelete,
  cutCommonFulfill,
    makeupSave
  } from "@/api/index"
  export default {
    name: "pbPart",
    data() {
      return {
        searchForm: {},
        updateModalFlagOne:false,
        productTypeData: [],
        productData: [],
        searchPbForm: {
          status:'0'
        },
        searchPbForms: {

},
        pbwidth: "",
        pbLength:"",
        pbNum:"",
        allLength:"",
        tip:"",
        productWidthList:[],
        loading: false,
        pbTableData: [],
        showSecondFlag:false,//显示二级半成品
        showYPFlag:false,//预拼
        pbTableColumns: [{
            type: 'selection',
            align: 'center',
            width: 55,
          },
          // {
          //   title: "序号",
          //   type: "index",
          //   align: "center"
          // },
          {
            key: "code",
            title: "订/工单编号",
            align: "center",
            width: 115,

          },
          {
            key: "customer",
            title: "客户名称",
            align: "center",
            width: 100,
          },
          {
            key: "name",
            title: "产品名称",
            align: "center",
            width: 110,
          },
          {
            key: "wide",
            title: "宽度(mm)",
            align: "center",
            width: 100,
          },
          {
            key: "lengths",
            title: "长度(m)",
            align: "center",
            width: 90,
          },
          {
            title: "级别",
            key: "level",
            width: 80,
            render: (h, params) => {
              let data = "";
              let className = '';
              switch (Number(params.row.level)) {
                case 1:
                  data = "正常";
                  className = 'statusZZ color-blues';
                  break;
                case 2:
                  data = "紧急";
                  className = 'statusZZ color-red';
                  break;
              }

              return h(
                "div", {
                  attrs: {
                    class: className
                  }
                },
                data
              )
            }
          },
         
          {
            key: "num",
            title: "数量",
            align: "center",
            width: 70,
          },
          {
            key: "unit",
            title: "单位",
            align: "center",
            width: 65,
          },
         
          {
            key: "awaitNo",
            title: "拼版数量",
            align: "center",
            width: 100,
            render: (h, params) => {
              let _this = this;
              return h('Input', {
                style: {
                  width: '100%',
                  textAlign: 'center'
                },
                props: {
                  value: params.row.awaitNo || '',
                  type: 'number'
                },
                on: {
                  'on-change': e => {
                    if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                      params.row.awaitNo = Number(e.target.value);
                    } else {
                      params.row.awaitNo = e.target.value;
                    }
                    if (!Number.isInteger(params.row.awaitNo) || params.row.awaitNo < 1) {
                      this.$Message.warning('数量只能为整数，而且需要大于0！');
                      return;
                    }
                    this.$set(_this.pbTableData, params.index, params.row);
                    this.selectTab()
                    this.searchPbForms={}
                  }
                }
              });


            }
          },
          {
            key: "breadth",
            title: "拼版幅宽",
            /* slot:'productLength',*/
            width: 120,
            render: (h, params) => {
              return h('div',
                [
                  params.row.widthArr.map((item, index) => {
                    return h('Input', {
                      style: {
                        display: 'inline-block',
                        marginRight: '5px',
                        marginBottom: '5px',
                        width: '80px'
                      },
                      props: {
                        value: item.width
                      },
                      on: {
                        'on-blur': (event) => {
                          params.row.widthArr[index].width = event.target.value;
                          this.$set(this.pbTableData, params.index, params.row);
                          this.selectTab()
                        }
                      }
                    })
                  }),
                  h(
                    "div", {
                      class: {
                        'iconfont table-tianjia table-button-div color-blue': true
                      },
                      domProps: {
                        title: '添加'
                      },
                      on: {
                        click: () => { //编辑
                          this.addBtn(params.row, params.index);
                          this.selectTab()
                          this.searchPbForms={}
                        }
                      }
                    },
                    ""
                  ),
                  h(
                    "div", {
                      class: {
                        'iconfont table-delete table-button-div color-light-red': true
                      },
                      domProps: {
                        title: '删除'
                      },
                      on: {
                        click: () => { //编辑
                          this.deleteBtn(params.row, params.index);
                          this.selectTab()
                          this.searchPbForms={}
                        }
                      }
                    },
                    ""
                  ),

                ])


            }
          },
          {
            title: "状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let data = "";
              let className = '';
              switch (Number(params.row.status)) {
                case 0:
                  data = "未拼版";
                  className = 'table-status border-color-orange';
                  break;
                  case 1:
                  data = "拼版中";
                  className = 'table-status border-color-blue';
                  break;
                case 2:
                  data = "拼版完成";
                  className = 'table-status border-light-green';
                  break;
              }

              return h(
                "button", {
                  attrs: {
                    class: className
                  }
                },
                data
              )
            }
          },
          // {
          //   key: "operateTime",
          //   title: "时间",
          //   align: "center",
          //   width: 90,
          // },
          {
            title: "操作",
            key: "action",
            width: 190,
            // align: "center",
            // fixed:'right',
            render: (h, params) => {
              return h("div", [
              h(
                  "button", {
                    style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                    on: {
                      click: () => { //修改状态
                        this.editStatusOne(params.row);
                      }
                    }
                  },
                  "修 改"
                ),
                h(
                  "button", {
                    style: {
                                          // marginTop: "5px",
                          marginRight: "10px",

                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF9900',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "撤销拼版",
                          content: "是否撤销当前拼版?",
                          onOk: () => {
                            recallMakeupSave({
                              code: params.row.code,
                              })
                              .then(res => {
                                if (res.code == 200) {
                                  this.$Message.success('撤销成功！');
                                  this.searchData()
                                }
                              })
                          }
                        });
                      }
                    }
                  },
                  "撤 销"
                ),
                h(
                  "button", {
                    style: {
                                          // marginTop: "5px",
                          // marginRight: "10px",

                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'rgb(190 25 177 / 62%)',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "裁切",
                          content: "是否确认去裁切?",
                          onOk: () => {
                            cutGoSlice({
                              ...params.row
                            }
                            )
                              .then(res => {
                                if (res.code == 200) {
                                  this.$Message.success('操作成功！');
                                  this.searchData()
                                }
                              })
                          }
                        });
                      }
                    }
                  },
                  "裁 切"
                ),
              //   h(
              //   "button", {
              //     style: {
              //       marginRight: "10px",
              //                             display:"inline",
              //                             cursor: 'pointer',
              //                             padding:"2px 6px",
              //                             background:'#5E5DFE',
              //                             color:"white",
              //                             // borderRadio:'5px',
              //                             border:"none",
              //                           },
              //   on: {
              //     click: () => { //修改状态
              //       this.printRow(params.row);
              //     }
              //   }
              // },
              //   "贴 标"
              // ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          marginTop:'5px',
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(253, 90, 91)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认删除?",
                onOk: () => {
                  cutCommonDelete({
                    id:params.row.id,
                    type:1,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchData()
                      this.$Message.success('删除成功！');
                    }
                  })
                }
              });
                  }
                }
              },
                "删 除"
              ),
              h(
                "button", {
                  style: {
                    marginTop:'5px',
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(60, 212, 151)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认完成?",
                onOk: () => {
                  cutCommonFulfill({
                    id:params.row.id,
                    type:1,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchData()
                      this.$Message.success('操作成功！');
                    }
                  })
                }
              });
                  }
                }
              },
                "完 成"
              ),
              ]);

            }
          }
        ],
        updateModalFlag:false,
        selectedRow:{},
        selectedPro: {},
        imgUrl: '',
        selectedRows: [],
        pageNum:1,
        pageSize:15,
        total:0,
        makeInfo:{},
        paperWideArr:[],
        productList:[],
        makeUpObj:{},
        makeDom:[],
        surePb:{},
        remWidth:0,
      }
    },
    methods: {
      makeupSaveFun(){
        let art = this.selectedRows
        let isContinue = true
        art.map( item => {
          if(item.awaitNo == 0||item.status == 2){
            isContinue = false
          }
        })
        if(!isContinue){
          this.$Message.warning("订单拼版已完成，请检查订单状态")
          return
        }
        this.$Modal.confirm({
                          title: "保存拼版结果",
                          content: "是否确认保存拼版?",
                          onOk: () => {
                            let params = this.surePb
                            makeupSave(params).then(res => {
                                if(res.code == 200){
                                  this.$Message.success("保存拼版成功")
                                  this.makeInfo={}
                                  this.makeDom= []
                                  this.makeUpObj= {}
                                  this.paperWideArr=[]
                                  this.searchPbForms={}
                                  this.selectedRows=[]
                                  this.searchData()
                                }
                            })
                          }
                        });
        
      },
      printRow(v){
        let params = {
          id : v.id
        }
        cutPaperMakeupPDF(params)
                    .then(res =>{
                         if(res.code == 200){
                             window.open(res.data.result,"_blank");
                         }
                    })
            },
      makeupOptFun(){
        console.log("88888888",this.makeInfo,this.searchPbForms);
        // return
        const data = this.$refs.pbTable.getSelection();
        this.selectedRows = this.$refs.pbTable.getSelection();
        data.map( item => {
          item.breadth = item.widthArr.map(obj => obj.width).join('-');
          item.makeupNo = item.num
        })
        if (data.length === 0) {
          this.$Message.warning('请勾选订单！');
          return
        }
        if(!this.makeInfo.goodsIds){
          this.$Message.warning("请选择物料宽度")
          return
        }
        // this.$Modal.confirm({
        //                   title: "拼版",
        //                   content: "是否确认拼版?",
        //                   onOk: () => {
                            let params = this.makeInfo
        makeupOpt(params).then( res => {
          if(res.code == 200){
            this.surePb = res.data
            let reaArr = []
            this.makeUpObj = res.data
            let arr = res.data.splitsWideStr.split("-")
            arr.map( item => {
              reaArr.push({
                reaWidth: item,
                showWidth:Math.round(item/res.data.goodsWide*300),
              })
            })
            const totalWidthJia  = reaArr.reduce((sum, item) => sum + item.showWidth, 0);
            const totalWidth  = reaArr.reduce((sum, item) => sum + Number(item.reaWidth), 0);
            let remWidth = res.data.goodsWide - totalWidth
            this.remWidth = remWidth
            let remWidths = 300 - totalWidthJia
            reaArr.push({
                reaWidth: `R:${remWidth}`,
                showWidth:remWidths,
              })
            this.makeDom = reaArr
          }
        })
                        //   }
                        // });
        
      },
      selectTab(v) {
        this.searchPbForms={}

        const data = this.$refs.pbTable.getSelection();
        this.selectedRows = this.$refs.pbTable.getSelection();
        data.map( item => {
          item.breadth = item.widthArr.map(obj => obj.width).join('-');
          item.makeupNo = item.num
        })
        if (data.length === 0) {
          // this.$Message.warning('请勾选数据！');
          return
        }
        getMakeupInfos(data).then(res => {
          if(res.code == 200){
            this.makeInfo = res.data
            this.getPaperWideFun(res.data.plateInfos)
          }
        })
        // console.log(v)
        // if (v.length > 0) {
        //   this.selectedRows = v;
        // }
        // this.getPbWidth();
      },
      getPaperWideFun(obj){
        getPaperWide(obj).then(res => {
          if(res.code == 200){
            this.paperWideArr = res.data
          }
        })
      },
      deleteBtn(v, index) {
        if (v.widthArr.length > 0 && v.widthArr.length >1) {
          v.widthArr.splice(v.widthArr.length - 1, 1);
           let ids = this.selectedRows.map(item => item.id);
           this.pbTableData.forEach(item => {
             if (ids.indexOf(item.id) > -1) {
               item._checked = true;
             } else {
               item._checked = false;
             }
           });
          this.$set(this.pbTableData, index, v)
        }

      },
      getProductList() {
        getNoMakeupProNameList().then( res => {
        if(res.code == 200){
          this.productList = res.data
        }
      })
    },
      addBtn(v, index) {
        let ids = this.selectedRows.map(item => item.id);
        let value = v.widthArr[0].width;
        let arr = [{
          width: Math.ceil(value)
        }]
        let copyArr = v.widthArr.concat(arr);
        v.widthArr = [].concat(copyArr)
        //遍历
        if (ids.indexOf(v.id) > -1) {
          v._checked = true;
        } else {
          v._checked = false;
        }
        this.pbTableData.forEach(item => {
          if (ids.indexOf(item.id) > -1) {
            item._checked = true;
          } else {
            item._checked = false;
          }
        });

        this.$set(this.pbTableData, index, v);
      },
      editStatus(v) {
        this.updateModalFlag = true;
        this.selectedRow = {
          ...v
        };
      },
      editStatusOne(v) {
      console.log("22222",v);
      this.updateModalFlagOne = true;
      this.selectedRow = {
        ...v,
        level:(v.level).toString()
      };
      // this.newStatus = ''
    },
    submitUpdate() {
      let params = {
        ...this.selectedRow,
        type:1,
        // machine:!!this.selectedRow.machineName? this.selectedRow.machineName:''
      }
      // delete params.machineName
      cutCommonUpdate(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('修改成功！');
            this.updateModalFlagOne = false;
              this.searchData()
          }
        })
    },
      //保存
      savePbBtn() {
        let selectedRows = this.$refs.pbTable.getSelection();
        if (selectedRows.length === 0) {
          this.$Message.warning('请勾选数据！');
          return
        }
        if (!this.searchPbForm.productWidth ) {
          this.$Message.warning('请选择拼版宽度！');
          return
        }
        this.searchPbForm.showYPFlag = (this.showYPFlag?1:0);
        this.imgUrl = ''
        let arr = [];
        selectedRows.forEach(item => {
          let newArr = [];
          if (item.widthArr && item.widthArr.length > 0) {
            item.widthArr.forEach(item => {
              if (item.width) {
                newArr.push(item.width)
              }
            })
          }
          arr.push({
            partNo: item.partNo,
            num: item.count,
            list: newArr
          })
        })
        let params = {
          ...this.searchPbForm,
          pbNum:this.pbNum,
          list: arr
        }
        console.log(params)
        savePbResult(params)
          .then(res => {
            if (res.code == 200) {
              this.$Message.success('保存成功！');
              this.searchData()
            }
          })

      },
      handleChangePage(page) {
                this.pageNum = page;
                this.searchData()
            },
            handlePageSizeChange(size) {
                this.pageSize = size;
                this.searchData()
            },
      recallApply(v) {

this.$Modal.confirm({
  title: "确认删除",
  content: "您确认要删除吗?",
  onOk: () => {
    let params = {
      id: v.id,
    }
    getPartDeleteById(params)
      .then(res => {
        if (res.code == 200) {
          this.$Message.success('删除成功!');
          this.getCutPaperPasteOptFun()
        }
      })
  }
});

},
      //计算
      calculationPbBtn() {
        let selectedRows = this.$refs.pbTable.getSelection();
        if (selectedRows.length === 0) {
          this.$Message.warning('请勾选数据！');
          return
        }
        if (!this.searchPbForm.productWidth) {
          this.$Message.warning('请选择拼版宽度！');
          return
        }
        this.searchPbForm.showYPFlag = (this.showYPFlag?1:0);
        this.imgUrl = ''
        let arr = [];
        selectedRows.forEach(item => {
          let newArr = [];
          if (item.widthArr && item.widthArr.length > 0) {
            item.widthArr.forEach(item => {
              if (item.width) {
                newArr.push(item.width)
              }
            })
          }
          arr.push({
            partNo: item.partNo,
            num: item.count,
            list: newArr
          })
        })
        let params = {
          ...this.searchPbForm,
          list: arr
        }
        generatePbResultImg(params)
          .then(res => {
            if (res.code == 200) {
              this.$Message.success('计算成功！');
              this.imgUrl = res.data.url;
              this.pbNum = res.data.num;
              this.pbLength = res.data.pbLength;
              this.tip = res.data.tip;
            }
          })
      },
      inputRow(e) {
        console.log(e.target.value)
        console.log(this.pbTableData)
        /* console.log(index)
         console.log(value)
         v.widthArr[index].wdith= value;*/
      },
      selectPro(v) {
        if (v) {
          let obj = this.getInfoById(this.productData, v);
          this.selectedPro = obj;
          this.searchPbForm.productId = obj.productCategoryId;
          this.searchPbForm.productWidth = obj.width;
          this.searchPbForm.productLength = obj.length / 1000;
          this.searchData()
        } else {
          this.searchPbForm = {}
          this.pbTableData = []
        }

      },
      getInfoById(data, id) {
        let obj = ''
        data.forEach(item => {
          if (item.productId == id) {
            obj = item;
            return
          }
        })
        return obj
      },
      searchDataBtn(){
        this.pageNum = 1
        this.searchData()
      },
      searchData() {
        
        let params = {
          data:{
            ...this.searchPbForm
          },
          pageNum:this.pageNum,
          pageSize:this.pageSize,
        }
        this.loading = true
        getPageList(params)
          .then(res => {
            this.loading = false
            if (res.code == 200) {
              this.pbTableData = res.data.records;
              this.total = res.data.total
              this.pbTableData.forEach(item => {
                item.widthArr = [{
                  width: item.breadth
                }]
              })
            }
          })
      },
      getReaminWidth(){
       var pId =  this.searchPbForm.productId
        var param = new Object;
        param.productId = pId;
        var types = new Array;
        types.push(1);
        if(this.showSecondFlag){
          types.push(2);
        }
        param.types = types;
        console.log(param)
         this.productWidthList = [];
        findGoodsWidth(param)
          .then(res => {
            if (res.code == 200) {
              this.productWidthList = res.data;
              this.getRemainLength();
            }
          })
      },
      getRemainLengthFun(v){
        let obj = {}
        this.paperWideArr.map(item => {
          if(v== item.goodsIds){
            obj = item
          }
        })
        this.makeInfo.goodsIds = obj.goodsIds
        this.makeInfo.goodsLength = obj.lengths
        this.makeInfo.goodsWide = obj.wide
        console.log("this.makeInfo",this.makeInfo);
      },
      getRemainLength(){//查询可用长度
      //this.searchPbForm.remainLength = "可用长度0";
      if(!this.searchPbForm.productId || !this.searchPbForm.productWidth){
        return;
      }
      var types = new Array;
      types.push(1);
      if(this.showSecondFlag){
        types.push(2);
      }
      this.allLength = "可用长度0";
      let params = {
        productId:this.searchPbForm.productId,
        width:this.searchPbForm.productWidth,
        types:types
      };
      findGoodsLength(params)
        .then(res => {
          if (res.code == 200) {
            this.allLength = "可用长度"+res.data;
          }
        })

      },
      init() {
        //this.getProductData()
        this.searchData()
        // this.getProTypeData()
      },
      getProTypeData() {
        getPbProducts()
          .then(res => {
            if (res.code == 200) {
              this.productTypeData = res.data;
            }
          })
      },
      selectProType(v) {
        console.log(v)
        if (v) {
          this.searchData();
          this.getReaminWidth();
          this.allLength = "";
        }

      },
      getProductData() {
        getFirstProductList()
          .then(res => {
            if (res.code == 200) {
              this.productData = res.data;
              this.searchPbForm.proId = res.data[0].id;
              let obj = this.getInfoById(this.productData, res.data[0].id);
              this.selectedPro = obj;
              this.searchPbForm.productId = obj.productCategoryId;
              this.searchPbForm.productWidth = obj.width;
              this.searchPbForm.productLength = obj.length / 1000;
            }
          })
      },
      getPbWidth() { //计算拼版的宽度
        let ids = this.selectedRows.map(item => item.id);
        let allPbWidth = 0;
        this.pbTableData.forEach(item => {
          if (ids.indexOf(item.id) > -1 && item.widthArr && item.widthArr.length > 0) {
            for(var i=0;i<item.widthArr.length;i++){
              allPbWidth+=Number(item.widthArr[i].width);
            }
          }
        });
         this.pbwidth=allPbWidth;
      }
    },
    computed: {
      tableHeight() {
        return document.documentElement.clientHeight - 250;
      },
    },
    mounted() {
      this.init()
    }

  }
</script>

<style scoped>
.ceshi{
  position: relative;
    margin-top: 20px;
    border: 2px solid #e8eaec;
    border-left: 2px solid #ff0000;
    border-top:2px solid #ff0000;
}
.ceshi::after {
  content: ' ';
display: inline-block;
-webkit-transform: rotate(314deg);
-ms-transform: rotate(314deg);
transform: rotate(314deg);
height: 0.5rem;
width: 0.5rem;
border-width: 0 0 2px 2px;
border-color: #ff0000;
border-style: solid;
position: absolute;
top: 337px;
left: -5px;
  }
  .icon{
  position: absolute;
    
}
.icon::after {
  content: ' ';
display: inline-block;
-webkit-transform: rotate(224deg);
-ms-transform: rotate(224deg);
transform: rotate(224deg);
height: 0.5rem;
width: 0.5rem;
border-width: 0 0 2px 2px;
border-color: #ff0000;
border-style: solid;
position: absolute;
left: 287px;
top: -5px;
  }
  .enums{
    height: 40px;
    border: 1px solid #326CFB;
    color: #326CFB;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pbPart.vue